/* eslint-disable no-undef */
import axios from "axios"
import Cookies from "js-cookie"

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_URL,
  timeout: 30000,
  headers: {
    "X-Custom-Header": "foobar"
  }
})

API.interceptors.request.use(
  function (config) {
    const token = Cookies.get("hrme_token")
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

API.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response?.request?.status == 401) {
      window.location.href = "/login"
    }

    return Promise.reject(error)
  }
)

export default API
